export const GET_INGREDIENTS_SUCCESSFUL: "GET_INGREDIENTS_SUCCESSFUL" =
  "GET_INGREDIENTS_SUCCESSFUL";
export const GET_INGREDIENTS_REQUEST: "GET_INGREDIENTS_REQUEST" =
  "GET_INGREDIENTS_REQUEST";
export const GET_INGREDIENTS_ERROR: "GET_INGREDIENTS_ERROR" =
  "GET_INGREDIENTS_ERROR";
export const GET_ORDER_REQUEST: "GET_ORDER_REQUEST" = "GET_ORDER_REQUEST";
export const GET_ORDER_SUCCESSFUL: "GET_ORDER_SUCCESSFUL" =
  "GET_ORDER_SUCCESSFUL";
export const GET_ORDER_ERROR: "GET_ORDER_ERROR" = "GET_ORDER_ERROR";
export const CLEAR_ORDER_NUMBER: "CLEAR_ORDER_NUMBER" = "CLEAR_ORDER_NUMBER";
export const GET_INGREDIENT: "GET_INGREDIENT_SUCCESSFUL" =
  "GET_INGREDIENT_SUCCESSFUL";
export const CLEAR_INGREDIENT: "CLEAR_INGREDIENT" = "CLEAR_INGREDIENT";
export const CREATE_CURRENT_INGREDIENT: "CREATE_CURRENT_INGREDIENT" =
  "CREATE_CURRENT_INGREDIENT";
export const REPLACE_BUN_INGREDIENT: "REPLACE_BUN_INGREDIENT" =
  "REPLACE_BUN_INGREDIENT";
export const DELETE_CONSTRUCTOR_ITEM: "DELETE_CONSTRUCTOR_ITEM" =
  "DELETE_CONSTRUCTOR_ITEM";
export const TARGET_CARD_INGREDIENT: "TARGET_CARD_INGREDIENT" =
  "TARGET_CARD_INGREDIENT";
export const SET_SORTED_ARRAY: "SET_SORTED_ARRAY" = "SET_SORTED_ARRAY";
export const WS_CONNECTION_START: "WS_CONNECTION_START" = "WS_CONNECTION_START";
export const WS_CONNECTION_SUCCESS: "WS_CONNECTION_SUCCESS" =
  "WS_CONNECTION_SUCCESS";
export const WS_CONNECTION_ERROR: "WS_CONNECTION_ERROR" = "WS_CONNECTION_ERROR";
export const WS_CONNECTION_CLOSED: "WS_CONNECTION_CLOSED" =
  "WS_CONNECTION_CLOSED";
export const WS_GET_MESSAGE: "WS_GET_MESSAGE" = "WS_GET_MESSAGE";

interface IPromise {
  ok: boolean;
  json: () => void;
}

export default function checkResponse(response: IPromise) {
  if (!response.ok) {
    throw new Error("Ответ сети был не ok.");
  }
  return response.json();
}
